import apiClient from '../config/api';
import {
  CreatePaymentLinkRequest,
  CreatePaymentLinkResponse,
  PaymentStatusResponse,
} from '../types';

/**
 * Service pour la gestion des paiements Stripe
 */
class PaymentService {
  /**
   * Créer un lien de paiement Stripe pour une facture
   * @param request - Données de la requête de création de lien
   * @returns Réponse avec l'URL du lien de paiement
   */
  async createPaymentLink(request: CreatePaymentLinkRequest): Promise<CreatePaymentLinkResponse> {
    console.log('💳 Création d\'un lien de paiement:', request);
    try {
      const response = await apiClient.post<CreatePaymentLinkResponse>(
        '/api/payments/create-link',
        request
      );
      console.log('✅ Lien de paiement créé:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Erreur lors de la création du lien de paiement:', error);
      throw error;
    }
  }

  /**
   * Récupérer le statut de paiement d'une facture
   * @param factureId - ID de la facture
   * @returns Statut du paiement
   */
  async getPaymentStatus(factureId: number): Promise<PaymentStatusResponse> {
    console.log('📊 Récupération du statut de paiement pour la facture:', factureId);
    try {
      const response = await apiClient.get<PaymentStatusResponse>(
        `/api/payments/status/${factureId}`
      );
      console.log('✅ Statut de paiement récupéré:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Erreur lors de la récupération du statut:', error);
      throw error;
    }
  }

  /**
   * Annuler un lien de paiement existant
   * @param factureId - ID de la facture
   */
  async cancelPaymentLink(factureId: number): Promise<void> {
    console.log('🚫 Annulation du lien de paiement pour la facture:', factureId);
    try {
      await apiClient.delete(`/api/payments/cancel-link/${factureId}`);
      console.log('✅ Lien de paiement annulé');
    } catch (error: any) {
      console.error('❌ Erreur lors de l\'annulation du lien:', error);
      throw error;
    }
  }

  /**
   * Rediriger vers le lien de paiement Stripe
   * @param paymentUrl - URL du lien de paiement
   */
  redirectToPayment(paymentUrl: string): void {
    console.log('🔗 Redirection vers le lien de paiement Stripe');
    window.location.href = paymentUrl;
  }
}

export default new PaymentService();
